export class AlunoPremiado {
  constructor(nome, nivelRioplatense = false, isSuplenteRioplatense = false) {
    this.nome = nome
    this.nivelRioplatense = nivelRioplatense
    this.isSuplenteRioplatense = isSuplenteRioplatense
  }
}
